import * as types from "../actionTypes";
import waitForEvent from "utils/events/waitForEvent";
import { showEvent } from "actions/actionCreators/snackbarActions";

function beginAjaxCall() {
  return { type: types.BEGIN_AJAX_CALL };
}

function ajaxCallError() {
  return { type: types.AJAX_CALL_ERROR };
}

function endAjaxCall() {
  return { type: types.END_AJAX_CALL };
}

export function beginAsyncCommand(commandId, correlationId, commandType, commandData) {
  return { type: types.BEGIN_ASYNC_COMMAND, payload: { commandId, correlationId, commandType, commandData } };
}

export function endAsyncCommand(commandId, correlationId) {
  return { type: types.END_ASYNC_COMMAND, payload: { commandId, correlationId } };
}

export function sendHttpRequest(ajaxProm) {
  return async dispatch => {
    dispatch(beginAjaxCall());
    try {
      const result = await ajaxProm;
      dispatch(endAjaxCall());
      return result;
    } catch (error) {
      dispatch(ajaxCallError(error));
      throw error;
    }
  };
}

export function sendHttpCommandAndWaitForEvent(
  ajaxProm,
  notification,
  eventTypes = [],
  showSuccessNotification = true
) {
  return async dispatch => {
    const { commandId, correlationId } = await dispatch(sendHttpRequest(ajaxProm));
    dispatch(beginAsyncCommand(commandId, correlationId, notification));
    try {
      const event = await waitForEvent(correlationId, eventTypes);
      if (event.ok) {
        if (showSuccessNotification) {
          dispatch(showEvent(event));
        }
      } else {
        dispatch(showEvent(event));
      }
      return event;
    } catch (error) {
      dispatch(endAsyncCommand(commandId, correlationId));
      throw error;
    }
  };
}
